<template>
  <div class="wrap">
    <h3 class="title">1V1约课</h3>
    <ul class="course-content">
      <li class="course-item" v-for="item in list" :key="item.id">
        <div class="course-img">
          <img :src="item.cover" alt="" />
        </div>
        <div class="course-desc">
          <h4 class="course-title">{{ item.name }}</h4>
          <div class="course-time" v-if="item.start_time">
            上课时间
            <span>{{ item.start_time.substring(0, 16) }}</span>
          </div>
          <div class="course-time-block" v-else></div>
        </div>
        <div class="study-state">
          <div class="study-time not-begin" v-if="!Number(item.endNum)">未开始学习</div>
          <div class="complete-study study-time" v-else></div>
          <div class="start-study" @click="handleStartStudy(item)">开始学习</div>
        </div>
      </li>
    </ul>
    <div class="pagination">
      <el-pagination background  :current-page="pagination.page" @current-change="handleCurrentChange" :page-size="6" layout="total, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pagination: {
        page: 1,
        total: 0,
        num: 6,
      },
      curType: 0,
      list: [],
    }
  },
  created() {
    this.getCourseList()
  },

  methods: {
    async getCourseList() {
      const data = {
        page: this.pagination.page,
        num: this.pagination.num,
      }
      const res = await this.$axios.post('stu/course/my1V1Courses', data)
      if (res.data.status === 'success') {
        const listObj = res.data.data
        this.list = listObj.list
        this.pagination.total = listObj.count
      }
    },
    changeCourseType(idx) {
      this.curType = idx
      this.pagination.page = 1
      this.getCourseList()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getCourseList()
    },
    // 跳转到课程详情
    handleStartStudy(val) {
      this.$router.push({ path: '/oneclass/',
      query: {
        id: val.course_id
      }})

    },
  },
}
</script>

<style scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  height: 880px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.wrap ::-webkit-scrollbar {
    display: none;
  }
.title {
  font-size: 20px;
  color: #202020;
  padding-bottom: 17px;
  border-bottom: 1px solid #e8eaec;
}
.course-categories {
  margin: 20px 0;
}
.course-type {
  width: 84px;
  height: 34px;
  display: inline-block;
  line-height: 34px;
  color: #202020;
  font-size: 14px;
  text-align: center;
  border-radius: 17px;
  margin-right: 20px;
  cursor: pointer;
  transition: all 0.5s;
}
.active {
  background: #10a675;
  color: #ffffff;
}
.course-content {
  /* width: 940px; */
  display: flex;
  flex-wrap: wrap;
}
.course-item {
  border-radius: 4px;
  border: #e8eaec 1px solid;
  width: 29%;
  min-width: 190px;
  height: 312px;
  margin: 0 20px 20px 0;
}
ul li {
   list-style-type: none;
}
.course-img {
  position: relative;
  width: 100%;
  min-height: 125px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 4px 4px 0px 0px;
}
@media screen and (min-width: 1280px) {
  .course-img {
    height: 186px;
  }
}
@media screen and (max-width: 1280px) {
  .course-item {
    height: 260px;
  }
  .course-img {
    height: 125px;
  }
}

.course-img img {
  width: 100%;
  height: 100%;
}
.course-desc {
  padding: 0 10px;
  margin-bottom: 10px;
}
.course-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  color: #20242f;
  margin-bottom: 9px;
}
.course-time {
  font-size: 14px;
  color: #808695;
}
.course-time-block {
  height: 18px;
}
.course-time .course-time span {
  margin-right: 10px;
}
.study-state {
  display: flex;
  padding: 0 10px;
  justify-content: space-between;
}
.study-state div {
  width: 90px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 16px;
  font-size: 14px;
}
.study-state .study-time {
  text-align: left;
}
.complete-study {
  color: #808695;
}
.not-begin {
  color: #ff9c18;
}
.studying {
  color: #10a675;
}
.start-study {
  border: 1px solid #1872ed;
  color: #1872ed;
  cursor: pointer;
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #10a675;
}
</style>
